/* global axios */
import ApiClient from './ApiClient';

// V1 · Round Robin Universal · 2026-05-13 (Victor)
// Endpoint singular: GET → estado actual · PUT → actualiza toggle + agent_ids
class RoundRobinUniversalAPI extends ApiClient {
  constructor() {
    super('round_robin_universal', { accountScoped: true });
  }

  async get() {
    const res = await axios.get(this.url);
    return res.data;
  }

  async update({ enabled, agentIds }) {
    const payload = {};
    if (enabled !== undefined) payload.enabled = enabled;
    if (agentIds !== undefined) payload.agent_ids = agentIds;
    const res = await axios.put(this.url, payload);
    return res.data;
  }
}

export default new RoundRobinUniversalAPI();
